import React, { useState } from "react";
import { View, TouchableOpacity, Image } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { router } from "expo-router";
import { AppText } from "@/components/AppText";
import { FontFamilies } from "@/constants/Typography";
import Icons from "@/assets/icons";
import { LinearGradient } from "expo-linear-gradient";
import { TRACKING_EVENTS } from "@/constants/trackingEvents";
import { useTrackImpression, useTrackClick } from "@/hooks/tracking";

const BillNegotiatorCard: React.FC = () => {
  // Track when card is shown
  useTrackImpression(TRACKING_EVENTS.BILL_NEGOTIATOR_SHOWN, {});

  // const [showPopup, setShowPopup] = useState(false);

  // const handleClaimPress = () => {
  //   setShowPopup(true);
  // };

  // const handleClosePopup = () => {
  //   setShowPopup(false);
  // };

  // Track when "Claim discount" button is clicked
  const handleRequestDiscount = useTrackClick(
    TRACKING_EVENTS.BILL_NEGOTIATOR_CLICKED,
    {}
  )(() => {
    // setShowPopup(false);
    router.push("/bills/upload");
  });

  // const handleCancel = () => {
  //   setShowPopup(false);
  //   onCancel?.();
  // };

  return (
    <View style={styles.card}>
      <View style={styles.content}>
        <View style={styles.row}>
          <LinearGradient
            colors={["#68C54E", "#24AC74"]}
            style={styles.imageContainer}
          >
            <Icons.BillNegotiator width={58} height={47} />
          </LinearGradient>
          <View style={styles.textContainer}>
            <AppText style={styles.title}>Bill Negotiator</AppText>
            <AppText style={styles.headline}>Up to 20%</AppText>
          </View>
        </View>

        <View style={styles.divider} />

        <View style={styles.descriptionRow}>
          <View style={styles.iconContainer}>
            <Icons.SearchCircleGray />
          </View>
          <AppText style={styles.description}>
            Upload your bill and we’ll negotiate lower rates
          </AppText>
          <TouchableOpacity
            style={styles.button}
            onPress={handleRequestDiscount}
            activeOpacity={0.8}
          >
            <AppText style={styles.buttonText}>Claim</AppText>
          </TouchableOpacity>
        </View>
      </View>

      {/* Bill Negotiation Popup */}
      {/* <InternetBillNegotiationPopup
        visible={showPopup}
        onClose={handleClosePopup}
        onRequestDiscount={handleRequestDiscount}
        onCancel={handleCancel}
      /> */}
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    backgroundColor: "#FFFFFF",
    borderRadius: 16,
    marginHorizontal: 16,
    marginVertical: 8,
    borderWidth: 1,
    borderColor: "#EBEBEB",
    overflow: "hidden",
  },
  content: {
    paddingVertical: 12,
    paddingHorizontal: 12,
    gap: 8,
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    gap: 16,
  },
  imageContainer: {
    width: 80,
    height: 80,
    borderRadius: 12,
    overflow: "hidden",
    justifyContent: "center",
    alignItems: "center",
  },
  textContainer: {
    flex: 1,
    gap: 4,
  },
  title: {
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 15,
    color: "#161D14",
  },
  headline: {
    fontFamily: FontFamilies.InterTight.SemiBold,
    fontSize: 20,
    lineHeight: 24,
    color: "#000000",
  },
  divider: {
    height: 1,
    backgroundColor: "#F3F3F3",
    marginHorizontal: 0,
  },
  descriptionRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  iconContainer: {
    justifyContent: "center",
    alignItems: "center",
    marginRight: 2,
  },
  description: {
    flex: 1,
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 13,
    lineHeight: 19,
    letterSpacing: -0.26,
    color: "#161D14",
  },
  button: {
    backgroundColor: "#0F9129",
    borderRadius: 100,
    paddingVertical: 8,
    paddingHorizontal: 24,
    alignItems: "center",
    justifyContent: "center",
    borderWidth: 1,
    borderColor: "rgba(255, 255, 255, 0.12)",
  },
  buttonText: {
    fontFamily: FontFamilies.InterTight.SemiBold,
    fontSize: 15,
    lineHeight: 23,
    color: "#FFFFFF",
  },
});

export { BillNegotiatorCard };
